// extracted by mini-css-extract-plugin
export default {"toggleFiltersBoxButton":"side_filters-module___toggleFiltersBoxButton___ce517c41","root":"side_filters-module___root___b07d1fdb"};